const hyph = (s) => s.replace(/[A-Z]|^ms/g, '-$&').toLowerCase();
const mx = (rule, media) => (media ? `${media}{${rule}}` : rule);
const rx = (cn, prop, val) => `.${cn}{${hyph(prop)}:${val}}`;
const noAnd = (s) => s.replace(/&/g, '');

function cxsFactory(cache = {}, rules = [], updateThemeProvider) {
  let prefix = 'sh';
  let insert = (rule) => rules.push(rule);

  const parse = (obj, child = '', media) =>
    Object.keys(obj)
      .map((key) => {
        const val = obj[key];
        if (val === null) {
          return '';
        }
        if (typeof val === 'object') {
          const m2 = /^@/.test(key) ? key : null;
          const c2 = m2 ? child : child + key;

          return parse(val, c2, m2 || media);
        }
        const _key = key + val + child + media;
        if (cache[_key]) {
          return cache[_key];
        }
        // eslint-disable-next-line no-magic-numbers
        const className = prefix + rules.length.toString(36);
        insert(mx(rx(className + noAnd(child), key, val), media));
        cache[_key] = className;

        /**
         * Update The Redux State only on the Server Side.
         *
         */
        typeof window === 'undefined' && typeof updateThemeProvider === 'function' && updateThemeProvider(cache, rules);

        return className;
      })
      .join(' ');

  const exports = (...styles) => {
    return styles
      .map((style) => parse(style))
      .join(' ')
      .trim();
  };

  exports.css = () => rules.sort().join('');

  exports.reset = () => {
    cache = {};
    while (rules.length) {
      rules.pop();
    }
  };

  exports.prefix = (val) => (prefix = val);

  /* istanbul ignore else */
  if (typeof document !== 'undefined') {
    const {sheet} = document.head.appendChild(document.createElement('style'));
    insert = (rule) => {
      rules.push(rule);
      sheet.insertRule(rule, sheet.cssRules.length);
    };
  }

  return exports;
}

export default cxsFactory;
